(() => {
  const money = (cents) => (window.lqCart ? window.lqCart.formatMoney(cents) : `${(cents / 100).toFixed(2)} €`);

  // Miniatures [data-gallery-thumb] qui changent l'image principale [data-product-image].
  const bindGallery = (root) => {
    const image = root.querySelector('[data-product-image]');
    const thumbs = root.querySelectorAll('[data-gallery-thumb]');
    if (!image || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        image.src = thumb.getAttribute('data-gallery-thumb');
        thumbs.forEach((other) => other.classList.toggle('is-active', other === thumb));
      });
    });
  };

  // Formulaire [data-product-form] (snippets/product-form.liquid) : variantes, prix, quantité, ajout au panier.
  const bindForm = (root, { onAdded } = {}) => {
    const form = root.querySelector('[data-product-form]');
    const data = form?.querySelector('[data-product-json]');
    if (!form || !data) return;

    const product = JSON.parse(data.textContent);
    product.variants = product.variants || [];
    product.options = product.options || [];
    const preorder = form.dataset.preorder === 'true';
    const addLabel = form.dataset.addLabel || 'Ajouter au panier';
    const idInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');
    const submit = form.querySelector('[data-product-submit]');
    const message = form.querySelector('[data-product-message]');
    const prices = root.querySelector('[data-product-prices]');
    const image = root.querySelector('[data-product-image]');

    const currentVariant = () => {
      if (product.variants.length === 1) return product.variants[0];
      const selected = product.options.map((_, index) => form.querySelector(`input[name="option-${index}"]:checked`)?.value);
      return product.variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
    };

    const renderPrices = (variant) => {
      if (!prices) return;
      const parts = [];
      if (variant.compare_at_price > variant.price) {
        const old = document.createElement('s');
        old.textContent = money(variant.compare_at_price);
        const sale = document.createElement('span');
        sale.className = 'product-price product-price--sale';
        const percent = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
        sale.textContent = `${money(variant.price)} -${percent}%`;
        parts.push(old, sale);
      } else {
        const price = document.createElement('span');
        price.className = 'product-price';
        price.textContent = money(variant.price);
        parts.push(price);
      }
      prices.replaceChildren(...parts);
    };

    const update = () => {
      const variant = currentVariant();
      message.textContent = '';
      if (!variant) {
        submit.disabled = true;
        submit.textContent = 'Indisponible';
        return;
      }
      idInput.value = variant.id;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? addLabel : 'Épuisé';
      renderPrices(variant);
      if (image && variant.featured_image) image.src = variant.featured_image.src;
    };

    form.addEventListener('change', (event) => {
      if (event.target.name && event.target.name.startsWith('option-')) update();
    });

    form.querySelectorAll('[data-qty-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const next = (parseInt(qtyInput.value, 10) || 1) + Number(button.dataset.qtyStep);
        qtyInput.value = Math.max(1, next);
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const variant = currentVariant();
      if (!variant || !variant.available || !window.lqCart) return;

      const item = { id: variant.id, quantity: Math.max(1, parseInt(qtyInput.value, 10) || 1) };
      if (preorder) item.properties = { [window.lqCart.preorderProperty]: 'Oui' };

      submit.disabled = true;
      submit.textContent = 'Ajout…';
      message.textContent = '';
      try {
        await window.lqCart.add([item], { openDrawer: false });
        onAdded?.();
        window.lqCart.open();
        update();
      } catch (error) {
        update();
        message.textContent = error.message;
      }
    });

    update();
  };

  window.lqProduct = { bindGallery, bindForm };

  // Fiche produit : tout ce qui est déjà dans la page (le détail de la pré-commande s'initialise à l'ouverture).
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    bindGallery(root);
    bindForm(root);
  });
})();
